module.exports = __webpack_public_path__ + "static/media/expand-arrows.2695f064.svg";